import React, { useEffect, useRef } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

function Download() {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && video) {
                video.play();
            }
        }, { threshold: 0.5 });

        if (video) {
            observer.observe(video);
        }

        return () => {
            if (video) {
                observer.unobserve(video);
            }
        };
    }, []);

    return (
        <section id="download" className="py-5 bg-white">
            <Container>
                <Row className="justify-content-center mb-4">
                    <Col md={10} className="text-center" data-aos="fade-up">
                        <h2 className="mb-4" style={{ color: 'var(--primary-color)' }}>Conoce cómo funciona EduDrive</h2>
                        <div className="video-wrapper">
                            <video
                                ref={videoRef}
                                muted
                                loop
                                playsInline
                                controls
                                preload="none"
                                className="vertical-video"
                            >
                                <source src="/videoflujoyexplicacion.mp4" type="video/mp4" />
                                Tu navegador no soporta la reproducción de video.
                            </video>
                        </div>
                    </Col>
                </Row>

                <Row className="justify-content-center mt-5">
                    <Col md={8} className="text-center" data-aos="fade-up" data-aos-delay="200">
                        <h4 className="fw-bold text-muted">Estamos trabajando para ofrecerte la mejor experiencia</h4>
                        <p className="text-secondary">
                            La aplicación estará disponible muy pronto. Mientras tanto, puedes seguirnos para ser el primero en enterarte de su lanzamiento.
                        </p>
                        <div className="d-flex justify-content-center gap-3 mt-4 flex-wrap">
                            <Button variant="dark" size="lg" disabled>
                                App Store (Próximamente)
                            </Button>
                            <Button variant="secondary" size="lg" disabled>
                                Google Play (Próximamente)
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Download;
